import React from 'react'

const CateringMenuMobile = () => {
    return (
        <div>CateringMenuMobile</div>
    )
}

export default CateringMenuMobile